import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function WorkflowEmptyIcon({
  className,
  fill,
  height,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 40}
      viewBoxDimensions="0 0 40 40"
      width={width ?? 40}
    >
      <path
        clipRule="evenodd"
        d="M2 .496h21c.828 0 1.5.672 1.5 1.5v6c0 .829-.672 1.5-1.5 1.5H12v1.75c0 .967.784 1.75 1.75 1.75h7.5c1.795 0 3.25 1.455 3.25 3.25v1.75H38c.828 0 1.5.672 1.5 1.5v6c0 .829-.672 1.5-1.5 1.5h-8.5v3.5H38c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5H17c-.828 0-1.5-.672-1.5-1.5v-6c0-.828.672-1.5 1.5-1.5h11v-3.5H17c-.828 0-1.5-.671-1.5-1.5v-6c0-.828.672-1.5 1.5-1.5h6v-1.75c0-.966-.784-1.75-1.75-1.75h-7.5c-1.795 0-3.25-1.455-3.25-3.25v-1.75H2c-.828 0-1.5-.671-1.5-1.5v-6c0-.828.672-1.5 1.5-1.5zm26.75 31.5H17v6h21v-6h-9.25zm0-6.5H38v-6H17v6h11.75zM23 7.996H2v-6h21v6z"
        fill={fill ?? IconColors.LightGray}
        fillRule="evenodd"
      />
    </SimpleIcon>
  );
}
